import React from 'react';
import { motion } from 'framer-motion';
import { Activity, TrendingUp, Cpu } from 'lucide-react';
const modules = [{
  id: 'AI-01',
  icon: <Activity className="w-5 h-5" data-id="element-12" />,
  title: 'AI IMPACT',
  metric: '+38%',
  metricLabel: 'THROUGHPUT LIFT',
  desc: 'Quantify how AI coding assistants change delivery — lead time, PR volume, and review load — with causal, signal-clean attribution rather than vanity counts.',
  signals: ['AI-assisted vs. manual delta', 'Quality & rework guardrails', 'Per-team impact baselines']
}, {
  id: 'AI-02',
  icon: <TrendingUp className="w-5 h-5" data-id="element-13" />,
  title: 'AI ROI',
  metric: '4.2x',
  metricLabel: 'TOOLING RETURN',
  desc: 'Tie AI tooling spend to measurable engineering output. Turn seat costs into a defensible return number your CFO and board will accept.',
  signals: ['Cost-per-seat vs. output', 'Capitalizable AI work', 'Forecasted payback window']
}, {
  id: 'AI-03',
  icon: <Cpu className="w-5 h-5" data-id="element-14" />,
  title: 'AI ADOPTION',
  metric: '91%',
  metricLabel: 'ACTIVE COVERAGE',
  desc: 'See who is actually using AI tooling, where adoption stalls, and which teams need enablement — across Copilot, Cursor, and more.',
  signals: ['Active vs. licensed seats', 'Adoption by team & repo', 'Enablement gap detection']
}];
export function AIModules() {
  return <section id="ai-modules" className="py-24 bg-base relative hairline-t" data-id="element-15">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8 relative z-10" data-id="element-16">
        <div className="mb-16 font-mono" data-id="element-17">
          <div className="text-lime text-xs tracking-widest mb-4 flex items-center gap-3" data-id="element-18">
            <span className="w-2 h-2 bg-lime animate-pulse-fast" data-id="element-19" />
            §AI / WAYDEV EXCLUSIVE
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink uppercase tracking-tight mb-6" data-id="element-20">
            AI Intelligence Modules
          </h2>
          <p className="text-ink/60 text-sm max-w-2xl leading-relaxed hairline-l pl-6 border-ink/20" data-id="element-21">
            Signals no other system on this board can read. Available only on
            Waydev — measure the impact, return, and adoption of AI across your
            engineering org.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 hairline-t hairline-l" data-id="element-22">
          {modules.map((mod, i) => <motion.div key={mod.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          ease: 'easeOut'
        }} className="hairline-r hairline-b p-8 relative group hover:bg-lime/[0.03] transition-colors" data-id="element-23">
              {/* Corner crosshairs */}
              <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-lime/60 -translate-x-px -translate-y-px" data-id="element-24" />
              <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-lime/60 translate-x-px translate-y-px" data-id="element-25" />

              <div className="flex items-center justify-between font-mono text-[10px] tracking-widest text-ink/40 mb-8" data-id="element-26">
                <span className="text-lime" data-id="element-27">{mod.id}</span>
                <span className="bg-lime/15 text-lime px-2 py-0.5 border border-lime/40" data-id="element-28">
                  WAYDEV ONLY
                </span>
              </div>

              <div className="w-10 h-10 flex items-center justify-center hairline-all bg-lime/10 text-lime mb-6" data-id="element-29">
                {mod.icon}
              </div>

              <h3 className="font-mono text-sm font-bold text-ink tracking-widest mb-6" data-id="element-30">
                {mod.title}
              </h3>

              <div className="flex items-baseline gap-3 mb-6 pb-6 hairline-b" data-id="element-31">
                <span className="font-display text-5xl font-bold text-lime leading-none" data-id="element-32">
                  {mod.metric}
                </span>
                <span className="font-mono text-[10px] text-ink/40 tracking-widest" data-id="element-33">
                  {mod.metricLabel}
                </span>
              </div>

              <p className="font-mono text-xs text-ink/60 leading-relaxed mb-6" data-id="element-34">
                {mod.desc}
              </p>

              <ul className="space-y-2 font-mono text-xs" data-id="element-35">
                {mod.signals.map((sig, idx) => <li key={idx} className="flex items-start gap-2 text-ink/80" data-id="element-36">
                    <span className="text-lime mt-px" data-id="element-37">›</span>
                    <span className="leading-tight" data-id="element-38">{sig}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}